const mediaFieldsQuery =
`
  id
  alt
  caption
  credit
  url
  thumbnailURL
  filename
  mimeType
  filesize
  width
  height
  focalX
  focalY
  createdAt
  sizes {
    xlarge {
      url
      width
      height
      mimeType
      filesize
      filename
    }
    large {
      url
      width
      height
      mimeType
      filesize
      filename
    }
    medium {
      url
      width
      height
      mimeType
      filesize
      filename
    }
    thumbnail {
      url
      width
      height
      mimeType
      filesize
      filename
    }
    small {
      url
      width
      height
      mimeType
      filesize
      filename
    }
    xsmall {
      url
      width
      height
      mimeType
      filesize
      filename
    }
  }
`

export const fragmentMediaQuery =
`{
${mediaFieldsQuery}
}`

// Generated preview image for files that can't be shown inline (PDFs). Lives in
// its own collection with a smaller set of sizes than media.
export const fragmentMediaCoverQuery =
`{
  id
  alt
  url
  filename
  mimeType
  width
  height
  sizes {
    medium {
      url
      width
      height
      mimeType
      filesize
      filename
    }
    small {
      url
      width
      height
      mimeType
      filesize
      filename
    }
    xsmall {
      url
      width
      height
      mimeType
      filesize
      filename
    }
  }
}`

// Only worth fetching where covers are actually rendered — keeps the cover out
// of every other media query.
export const fragmentMediaWithCoverQuery =
`{
${mediaFieldsQuery}
  cover ${fragmentMediaCoverQuery}
}`
